/**
 * Site-wide contact addresses shown in the UI (footer, legal pages, "contact us" links), by category.
 * Single source of truth on the frontend — keep in sync with the backend addresses in
 * terraform email.tf (sales_email / support_email / privacy_email).
 */
export const CONTACT = {
  sales: 'sales@lakotasoftware.com',
  support: 'support@lakotasoftware.com',
  privacy: 'privacy@lakotasoftware.com',
} as const;
